import { useState } from "react"
import { useHistory } from "react-router-dom"
import { localizeDateTime } from "../../utils"

import { CheckCircleIcon } from "@chakra-ui/icons"

import DataTable from "../Common/DataTable"
import DeleteButton from "../Common/DeleteButton"
import EmptyState from "../Common/EmptyState"

const OrderList = ({ linkId, orders, removeOrder }) => {
  let history = useHistory()
  const [selected, setSelected] = useState([])

  return orders?.length ? (
    <DataTable
      rows={orders}
      columns={{
        orderId: { label: "N." },
        fullName: {
          label: "Cliente",
          render: (item) => `${item.surname} ${item.name}`,
        },
        timestamp: {
          label: "Data/Ora",
          render: (item) => localizeDateTime(item.timestamp),
        },
        hasFresco: {
          label: "F",
          sort: false,
          render: (item) =>
            !!item.hasFresco && (
              <CheckCircleIcon w={4} h={4} color="green.500" />
            ),
        },
        hasGastro: {
          label: "G",
          sort: false,
          render: (item) =>
            !!item.hasGastro && (
              <CheckCircleIcon w={4} h={4} color="green.500" />
            ),
        },
        phone: { label: "Telefono" },
        email: { label: "Email" },
        cityName: { label: "Consegna" },
        address: {
          label: "Indirizzo",
          render: (item) => (item.address ? item.address : "Ritiro"),
        },
        deleteAction: {
          label: "",
          sort: false,
          textAlign: "center",
          render: (item) => (
            <DeleteButton
              variant="textButton"
              onClick={() => removeOrder(item.id)}
            />
          ),
        },
      }}
      selected={selected}
      setSelected={setSelected}
      onRowClick={(item) => history.push(`/admin/ordini/${linkId}/${item.id}`)}
    />
  ) : (
    <EmptyState text="Nessun ordine" />
  )
}

export default OrderList
